import React from 'react';

export const Home = () => {
  return (
    <div className="min-h-screen">
      {/* Main Content */}
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {/* Dynamic Block1 */}
        <div className="mb-8" id="home-pendo-block-1"></div>

        {/* Dynamic Block2 */}
        <div className="mb-8" id="home-pendo-block-2"></div>
      </main>
    </div>
  );
};
